/**
 * @voltxampere/ui — NTC 10K thermistor variant (Sprint 43-6)
 *
 * Negative-temperature-coefficient thermistor with 10 kΩ resistance
 * at 25 °C. Beta typically 3950 K — the user reads a temperature-
 * dependent R via the resistor slider, full Steinhart-Hart curve
 * mapping arrives Sprint 47+ alongside thermal model integration.
 *
 * Reference: Vishay NTCLE100E3 / Murata NTC family. Engine zero-diff
 * invariant honored — canonical `resistor` engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const sensorNtc10k = {
    id: "ntc-10k",
    nameTr: "NTC 10K (Beta=3950, sıcaklık sensörü)",
    nameEn: "NTC 10K (Beta=3950, temperature sensor)",
    shortcut: "R",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "R",
    defaultValue: "10kΩ@25°C",
    schemaType: "resistor",
    defaultParams: { resistance: 10e3 },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=sensor-ntc-10k.js.map